exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-panel[data-v-28bcee79]{border-radius:4px;background:rgba(214,232,242,.5)}.close-btn[data-v-28bcee79]{position:absolute;top:3rem;right:3rem;z-index:10;cursor:pointer}", ""]);

// exports
